export default __webpack_public_path__ + "static/media/BB_23.4e96802c.png";